import React from "react";
import { Calendar, Star, Compass, DoorOpen } from "lucide-react";

// --- Trigger 1: Cleaners (Monday Dec 22 Only) ---
export const CleanersTrigger = ({ currentDay }) => {
  if (currentDay !== "2025-12-22") return null;

  return (
    <div className="mb-6 bg-stone-100 border-l-4 border-stone-400 rounded-r-xl p-4 flex items-center justify-between opacity-90 hover:opacity-100 transition-opacity">
      <div className="flex items-center gap-4">
        <div className="bg-white p-2 rounded-full text-stone-500">
          <DoorOpen className="w-5 h-5" />
        </div>
        <div>
          <h3 className="font-bold text-stone-700">Displacement: Cleaners</h3>
          <p className="text-xs text-stone-500 font-medium">
            Must be out of house: 10:00 AM — 11:30 AM
          </p>
        </div>
      </div>
    </div>
  );
};

// --- Trigger 2: Coffee Meeting (Tuesday Dec 23 Only) ---
export const CoffeeMeetingTrigger = ({ currentDay, onClick }) => {
  if (currentDay !== "2025-12-23") return null;

  return (
    <div
      onClick={onClick}
      className="mb-4 cursor-pointer group relative overflow-hidden bg-white border border-[#1F6F54]/30 rounded-xl p-4 shadow-sm hover:shadow-md hover:border-[#1F6F54] transition-all"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="bg-[#EAF4EF] p-2 rounded-full text-[#1F6F54]">
            <Calendar className="w-6 h-6" />
          </div>
          <div>
            <h3 className="font-bold text-stone-800 group-hover:text-[#1F6F54] transition-colors">
              11:00 AM · Coffee Meeting
            </h3>
            <p className="text-xs text-stone-500">Foxborough · Exploration</p>
          </div>
        </div>
        <div className="text-stone-300 group-hover:text-amber-500 transition-colors">
          <Star className="w-5 h-5" />
        </div>
      </div>
    </div>
  );
};

// --- Trigger 3: Life Coach Session (Tuesday Dec 23 Only) ---
export const LifeCoachTrigger = ({ currentDay, onClick }) => {
  if (currentDay !== "2025-12-23") return null;

  return (
    <div
      onClick={onClick}
      className="mb-6 cursor-pointer group relative overflow-hidden bg-[#F5F5F4] border-l-4 border-[#1F6F54] rounded-r-xl p-5 shadow-sm hover:shadow-md transition-all"
    >
      <div className="flex items-start gap-4">
        <div className="mt-1 text-[#1F6F54]">
          <Compass className="w-6 h-6" />
        </div>
        <div>
          <h3 className="font-serif text-lg text-[#1F6F54] italic mb-1">
            Life Coach Session — Year Review & Repair
          </h3>
          <div className="text-xs font-bold tracking-widest text-stone-400 uppercase mb-2">
            10:00 AM · Zoom
          </div>
          <p className="text-sm text-stone-500 leading-relaxed max-w-sm">
            This is not something to finish. It’s something to arrive at.
          </p>
        </div>
      </div>
    </div>
  );
};
